"use client"

import { useModalStatus } from "@privy-io/react-auth"
import { DialogContent } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import type { ComponentPropsWithoutRef } from "react"
import {
  isLikelyPrivyPopupElement,
  shouldPreventGachaDialogDismiss,
} from "./gacha-purchase-dialog"

type GachaDialogContentProps = ComponentPropsWithoutRef<
  typeof DialogContent
> & {
  preventDismiss?: boolean
}

export const GachaDialogContent = reatomComponent(
  ({
    onInteractOutside,
    preventDismiss = false,
    ...props
  }: GachaDialogContentProps) => {
    const { isOpen: isPrivyModalOpen } = useModalStatus()

    return (
      <DialogContent
        onInteractOutside={(event) => {
          onInteractOutside?.(event)
          if (event.defaultPrevented) return

          if (
            shouldPreventGachaDialogDismiss({
              isPrivyModalOpen,
              isPrivyPopupInteraction: isLikelyPrivyPopupElement(event.target),
              purchaseBusy: preventDismiss,
            })
          ) {
            event.preventDefault()
          }
        }}
        {...props}
      />
    )
  },
  "GachaDialogContent",
)
